import { useCallback, useEffect } from "react";

import { FallbackProps } from "react-error-boundary";

import { useQueryErrorResetBoundary } from "react-query";

interface Props extends FallbackProps {}

export function DefaultResetFallback(props: Props) {
  const { resetErrorBoundary } = props;
  const { reset } = useQueryErrorResetBoundary();
  const doReset = useCallback(tryAgain, [reset, resetErrorBoundary]);

  function tryAgain() {
    reset();
    resetErrorBoundary();
  }

  useEffect(doReset, [doReset]);

  return null;
}
